import React, { useState, useEffect } from 'react';
import {
  X, Copy, MessageCircle, Gift, Check, AlertCircle, Mail, MessageSquare, Link as LinkIcon
} from 'lucide-react';
import { db } from '../../../firebase';
import { TENANT_ID } from '../../../tenant';
import { doc, getDoc } from 'firebase/firestore';

const GiftModal = ({ isOpen, onClose, ticket }) => {
  const [copied, setCopied] = useState(false);
  const [giftLink, setGiftLink] = useState('');

  // ✅ 発行中/エラーは親（PossessionsCard）から渡す
  const issuing = !!ticket?.issuing;
  const issueErr = ticket?.issueErr || null;

    const [appConfig, setAppConfig] = useState({
      website_url: "",
      default_location_id: "",
    });
    const [defaultLocationName, setDefaultLocationName] = useState("");
    const [tenantInfoLoading, setTenantInfoLoading] = useState(false);

  const displayName = ticket?.product_name || 'チケット';
  const totalQty = Number(ticket?.quantity || 1);

  useEffect(() => {
    if (isOpen && (ticket?.url || ticket?.token)) {
      const url = String(ticket?.url || '').trim() || `${window.location.origin}/gift/receive/${ticket.token}`;
      setGiftLink(url);
    } else {
      setGiftLink('');
    }
  }, [isOpen, ticket]);
/*
  useEffect(() => {
    const loadTenantInfo = async () => {
      setTenantInfoLoading(true);

      try {
        const appRef = doc(db, "tenants", String(TENANT_ID), "config", "app");
        const appSnap = await getDoc(appRef);

        if (!appSnap.exists()) {
          setAppConfig({ website_url: "", default_location_id: "" });
          setDefaultLocationName("");
          return;
        }

        const appData = appSnap.data() || {};
        const websiteUrl = String(appData.website_url || "").trim();
        const defaultLocationId = String(appData.default_location_id || "").trim();

        setAppConfig({
          website_url: websiteUrl,
          default_location_id: defaultLocationId,
        });

        if (!defaultLocationId) {
          setDefaultLocationName("");
          return;
        }

        const locRef = doc(
          db,
          "tenants",
          String(TENANT_ID),
          "locations",
          defaultLocationId
        );
        const locSnap = await getDoc(locRef);

        if (!locSnap.exists()) {
          setDefaultLocationName("");
          return;
        }

        const locData = locSnap.data() || {};
        setDefaultLocationName(String(locData.name || "").trim());
      } catch (e) {
        console.error("[GiftModal] loadTenantInfo failed:", e);
        setDefaultLocationName("");
      } finally {
        setTenantInfoLoading(false);
      }
    };

    if (isOpen) {
      loadTenantInfo();
    }
  }, [isOpen]);

  // 開閉で状態を整える（見た目のチラつき防止）
  useEffect(() => {
    if (!isOpen) {
      setCopied(false);
    }
  }, [isOpen]);
  */
  useEffect(() => {
    const loadTenantInfo = async () => {
      setTenantInfoLoading(true);

      try {
        const appRef = doc(db, "tenants", String(TENANT_ID), "config", "app");
        const appSnap = await getDoc(appRef);

        if (!appSnap.exists()) {
          setAppConfig({
            website_url: "",
            default_location_id: "",
            default_location_name: "",
          });
          return;
        }

        const appData = appSnap.data() || {};

        setAppConfig({
          website_url: String(appData.website_url || "").trim(),
          default_location_id: String(appData.default_location_id || "").trim(),
          default_location_name: String(appData.default_location_name || "").trim(),
        });
      } catch (e) {
        console.error("[GiftModal] loadTenantInfo failed:", e);
        setAppConfig({
          website_url: "",
          default_location_id: "",
          default_location_name: "",
        });
      } finally {
        setTenantInfoLoading(false);
      }
    };

    if (isOpen) {
      loadTenantInfo();
    }
  }, [isOpen]);

  if (!isOpen || !ticket) return null;

  const buildMessage = () => {
    const qtyText = totalQty > 1 ? `（${totalQty}枚）` : '';

    const lines = [
      "ギフトをお届けします。",
      "",
      `🎁 ${displayName}${qtyText}`,
    ];

    if (appConfig.default_location_name) {
      lines.push("", `場所：${appConfig.default_location_name}`);
    }

    if (appConfig.website_url) {
      lines.push(`公式サイト：${appConfig.website_url}`);
    }

    lines.push(
      "",
      "受け取りはこちら",
      "",
      giftLink,
      "",
      "携帯番号を認証すると、すぐにご利用いただけます。"
    );

    return lines.join("\n");
  };

  const handleSendLine = () => {
    if (!giftLink || issuing) return;
    const message = buildMessage();
    window.open(`https://line.me/R/msg/text/?${encodeURIComponent(message)}`, '_blank');
    onClose?.();
  };

  const handleSendSms = () => {
    if (!giftLink || issuing) return;
    const message = buildMessage();
    window.open(`sms:&body=${encodeURIComponent(message)}`, '_blank');
  };

  const handleSendMail = () => {
    if (!giftLink || issuing) return;
    const subject = `ギフトをお送りします：${displayName}`;
    const body = buildMessage();
    window.open(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`, '_blank');
  };

  const copyLink = () => {
    if (!giftLink || issuing) return;
    navigator.clipboard.writeText(giftLink);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
      onClose?.();
    }, 800);
  };

  const iconBoxClass =
    'w-10 h-10 bg-gray-100 rounded-3xl flex items-center justify-center border border-gray-200/60 shadow-sm';

  const primaryBtnBase =
    'w-full py-3.5 rounded-3xl font-black flex items-center justify-center gap-2 transition-all active:scale-[0.98] shadow-sm';

  const secondaryBtnBase =
    'w-full py-3.5 rounded-3xl font-black flex items-center justify-center gap-2 transition-all active:scale-[0.98] bg-white border border-gray-200 text-gray-700 hover:bg-gray-50';

  const compactActionBtn =
    'flex-1 py-2.5 rounded-xl font-black text-xs flex items-center justify-center gap-2 transition-all active:scale-[0.98] bg-white border border-gray-200 text-gray-700 hover:bg-gray-50';

  const disableAll = !giftLink || issuing || tenantInfoLoading;

  return (
    <div className="fixed inset-0 bg-black/50 z-[14000] flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in font-sans">
      <div className="bg-white w-full max-w-sm rounded-3xl p-5 shadow-2xl border border-gray-100 relative animate-slide-up text-gray-900">
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 w-10 h-10 rounded-3xl bg-white border border-gray-200 shadow-sm flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-50 active:scale-[0.98] transition-all"
          aria-label="閉じる"
          title="閉じる"
        >
          <X size={18} />
        </button>
        {/* Header */}
        <div className="flex items-center gap-3 pr-10">
          <div className={iconBoxClass}>
            <Gift size={18} className="text-gray-700" />
          </div>
          <div className="min-w-0">
            <div className="text-[10px] text-gray-500 font-black uppercase tracking-[0.12em]">gift link</div>
            <div className="text-base font-black text-gray-900 tracking-tight">ギフトリンク</div>
          </div>
        </div>

        {/* Item */}
        <div className="mt-4 bg-gray-50/60 rounded-3xl p-4 border border-gray-100">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <div className="text-[10px] font-black text-gray-500 uppercase tracking-widest">Target Item</div>
              <div className="mt-1 text-sm font-black text-gray-900 leading-tight truncate">
                {displayName}
                {totalQty > 1 ? (
                  <span className="ml-2 text-[11px] font-black text-gray-500 bg-white px-2 py-0.5 rounded-xl border border-gray-200">
                    x {totalQty}
                  </span>
                ) : null}
              </div>
            </div>
            <div className="px-2.5 py-1 rounded-xl bg-white border border-gray-200 text-[10px] font-black text-gray-600 uppercase tracking-tight">
              1 link = 1 person
            </div>
          </div>

          <div className="mt-3 flex items-start gap-2 p-3 rounded-3xl border border-amber-200 bg-amber-50/70">
            <AlertCircle size={16} className="text-amber-600 shrink-0 mt-0.5" />
            <div className="text-[11px] text-amber-900 font-bold leading-relaxed">
              ギフトリンクは <span className="font-black">1人につき1つ</span> を、
              <span className="font-black"> LINE / SMS / メール</span>で
              <span className="font-black"> 個別に</span>送ってください。
              <div className="mt-1 text-[10px] text-amber-800">※最初に開いた方のみ受け取れます（1回限り）</div>
            </div>
          </div>

          {/* 発行中/エラー */}
          {issuing && <div className="mt-3 text-xs font-bold text-gray-500">リンク発行中...</div>}
          {issueErr && <div className="mt-3 text-xs font-bold text-red-600 break-words">{issueErr}</div>}
        </div>

        {/* Actions */}
        <div className="mt-4 space-y-3">
          <button
            onClick={handleSendLine}
            disabled={disableAll}
            className={`${primaryBtnBase} ${
              disableAll
                ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                : 'bg-gray-900 text-white shadow-sm hover:opacity-[0.98]'
            }`}
          >
            <MessageCircle size={18} className="fill-white" />
            LINEで送る
          </button>

          <div className="grid grid-cols-2 gap-2">
            <button
              onClick={handleSendSms}
              disabled={disableAll}
              className={`${compactActionBtn} ${disableAll ? 'opacity-60 cursor-not-allowed' : ''}`}
              title="SMSで送る"
            >
              <MessageSquare size={16} className="text-gray-500" />
              SMS
            </button>

            <button
              onClick={handleSendMail}
              disabled={disableAll}
              className={`${compactActionBtn} ${disableAll ? 'opacity-60 cursor-not-allowed' : ''}`}
              title="メールで送る"
            >
              <Mail size={16} className="text-gray-500" />
              メール
            </button>
          </div>

          {/* Copy */}
          <div className="pt-3 border-t border-gray-100">
            <div className="flex items-center gap-2 text-[10px] text-gray-500 font-black uppercase tracking-widest px-1">
              <LinkIcon size={12} /> link
            </div>

            <div className="mt-2 flex items-center gap-2 bg-gray-50/60 p-2 pl-3 rounded-3xl border border-gray-200">
              <div className="flex-1 overflow-hidden">
                <div className="text-[11px] font-mono text-gray-700 truncate">{giftLink || '(まだ発行されていません)'}</div>
              </div>

              <button
                onClick={copyLink}
                disabled={disableAll}
                className={`w-10 h-10 rounded-xl border shadow-sm flex items-center justify-center transition-all active:scale-[0.98] ${
                  disableAll
                    ? 'bg-gray-100 text-gray-300 border-gray-200 cursor-not-allowed'
                    : copied
                    ? 'bg-gray-900 text-white border-gray-900'
                    : 'bg-white text-gray-600 border-gray-200 hover:text-gray-900'
                }`}
                aria-label="リンクをコピー"
                title="リンクをコピー"
              >
                {copied ? <Check size={18} strokeWidth={3} /> : <Copy size={16} />}
              </button>
            </div>

            <button onClick={onClose} className={`${secondaryBtnBase} mt-3`}>
              <X size={16} className="text-gray-500" /> 閉じる
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftModal;